module.exports = __webpack_public_path__ + "media/images/menu/uranus-2fb61bc13fd63c3fb5f4fcb75c1ca5c6.jpg";